module.exports = __webpack_public_path__ + "static/img/demo_custom.93df8576.jpg";